import { OrganizationTitleDto, UserDto } from 'api/dtos/organizations/titles';
import { useTranslation } from 'react-i18next';
import Link from 'next/link';
import { RxDragHandleDots2 } from 'react-icons/rx';
import { Draggable } from '@hello-pangea/dnd';
import classNames from 'classnames';
import { MdClose } from 'react-icons/md';
import MembersListItem from 'components/lists/MemberList/ListItem';
import { Avatar } from 'components/Avatar';

interface Props {
  title: OrganizationTitleDto & { users?: UserDto[] };
  organizationId: string;
  index: number;
  onClickRemoveTitleFromMember: ({
    organizationId,
    userId,
    titleId
  }: {
    organizationId: string;
    userId: string;
    titleId: string;
  }) => void;
}
const TitlesRow = ({
  title,
  organizationId,
  index,
  onClickRemoveTitleFromMember
}: Props) => {
  const { t } = useTranslation(['organizations']);

  return (
    <Draggable draggableId={title.id} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...provided.draggableProps}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...provided.dragHandleProps}
          className={classNames(
            'flex w-full items-center justify-between py-2 rounded-lg',
            {
              'bg-primary-50 shadow-lg': snapshot.isDragging
            }
          )}
        >
          <div className="w-full">
            <div
              key={title.id}
              className="flex w-full items-center justify-between py-2"
            >
              <div className="flex items-center font-bold">
                <RxDragHandleDots2
                  size={20}
                  className="cursor-grab text-gray-400 mr-1"
                />
                {title.name}
              </div>
              <div>
                <Link
                  href={`/organizations/${organizationId}/members/titles/${title.id}`}
                >
                  <div className="text-primary-700">
                    {t('titleManagement.edit')}
                  </div>
                </Link>
              </div>
            </div>

            <div className="mt-4 pl-2 flex flex-col gap-4">
              {title?.users?.map((user) => (
                <div
                  key={user.id}
                  className="flex items-center justify-between "
                >
                  <div className="flex items-center">
                    <MembersListItem
                      avatar={<Avatar src={user.photoUrl} />}
                      label={user.name}
                    />
                  </div>
                  <div className="flex items-center">
                    <button
                      type="button"
                      onClick={() =>
                        onClickRemoveTitleFromMember({
                          organizationId,
                          userId: user.id,
                          titleId: title.id
                        })
                      }
                      className="text-red-600"
                      aria-label={t('accessibility.deleteTitle')}
                    >
                      <MdClose size={20} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </Draggable>
  );
};

export default TitlesRow;
